// extracted by mini-css-extract-plugin
module.exports = {"txcenter":"index_txcenter_1LtuY","otherIcon":"index_otherIcon_3FrCY","icon":"index_icon_t5yFG"};